export * from './item-detail-variant-rsd.module';
export * from './item-detail-variant-rsd.component';
